import React from 'react';

const NotFound = () => {
    return (
        <div className="font">
            <h2>This page you are looking for is not exixts</h2>
        </div>
    );
};

export default NotFound;